// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBTsgRCyGv3SX38-a8DXZN8SYo10eIbWMM",
  authDomain: "meme-creator-c6435.firebaseapp.com",
  databaseURL: "https://meme-creator-c6435.firebaseio.com",
  projectId: "meme-creator-c6435",
  storageBucket: "meme-creator-c6435.appspot.com",
  messagingSenderId: "433560889187",
  appId: "1:433560889187:web:442c2fed24b0231a771556",
  measurementId: "G-K3SJNTHPZB"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
